export class UrlHelper {
	static open(url: string, target?: string): void {
		if (target) window.open(url, target);
		else location.href = url;
	}

	static goBack(): void {
		const fromUrl = ((window as any).navigation?.activation?.from?.url) ?? null;
		if (fromUrl) {
			const url = new URL(fromUrl) || false;
			if (url && url.origin === window.location.origin) {
				window.history.back();
				return;
			}
		}
		window.location.href = window.location.origin;
	}
}
